import { Select as NextUSelect, SelectProps } from '@nextui-org/react';

export function Select(props: SelectProps) {
  return (
    <NextUSelect
      classNames={{
        trigger: [
          'bg-white',
          'shadow-none',
          'border-2',
          'border-primary',
          'data-[disabled=true]:border-default',
        ],
        value: [],
        listbox: [],
      }}
      {...props}
    >
      {props.children}
    </NextUSelect>
  );
}

export { SelectItem, type Selection } from '@nextui-org/react';
